<div class="sir-carousel" #slider>
    <div class="sir-carousel-viewport" #viewport>
        <div class="sir-carousel-container" #container>
            <ng-content></ng-content>
        </div>
    </div>
</div>
